module.exports = __webpack_public_path__ + "static/img_banner-abe69d6912f510067cf475dd186295c6.png";